import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f6f8dd12&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6f8dd12')) {
      api.createRecord('f6f8dd12', component.options)
    } else {
      api.reload('f6f8dd12', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=f6f8dd12&", function () {
      api.rerender('f6f8dd12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/natural_entities/Index.vue"
export default component.exports